import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import Header4 from '../../../../../Header/Header4';
import HomeHearder from 'src/components/Pages/Home/NewHome/HomeHearder'
import { MainBottom } from 'src/components/Pages/Guide/component/index'
import { unitsList } from 'src/components/Pages/Guide/component/Datas/normalDatas'
import './style.css'
function JoinUs(props) {
    const { data } = props;
    const JobList = [
        {
            JobName: "大数据开发工程师",
            responsibility: ["负责空基网站日常数据统计", "数据仓库、数据集市的模型设计与开发", "负责ETL数据准确性验证及ETL任务的优化", "负责ETL任务的各种异常和技术问题的解决", "与大数据平台和数据仓库的搭建"],
            requirement: ["本科及以上学历、计算机应用科学等相关专业", "有Hadoop/hive/Hbase/sparkistorm等大数据工具应用和开发经验", "熟悉Java/Python编程、能够使用Java或者Python等编程语言对数据进行处理", "对数据敏感、对新技术敏感，有一定的研究能力", "有海量数据开发经验和数据挖掘项目经验者优先", "性格积极且沉稳、勤奋严谨，有强烈的进取心、求知欲和团队合作精神"]
        },
        {
            JobName: "业务数据开发",
            responsibility: ["主要负责空基网站数据结算系统开发与维护", "负责实时数据业务开发"],
            requirement: ["2年以上工作经验、数据库基础扎实，熟悉主流数据库产品，如MySQL，精通SQL、储存过程开发、有较好SQL性能调优经验", "至少熟练使用Python、Shell、Perl等脚本语言之一", "熟悉hadoop、hive、spark、storm等分布式系统开发与维护，有流失计算开发经验者优先"],
        }
    ]
    return (
        <div className='Home_Introduce' >
            <div className='Home_IntroduceMain' id='Home_IntroduceMain'>
                {/* <Header4></Header4> */}
                <div className='Home_IntroduceTitle'>
                    {props.loginObj && props.loginObj.login && props.loginObj.token !== undefined
                        ?
                        <Header4 />
                        :
                        <HomeHearder />
                    }
                </div>
                <div className='Home_IntroduceMainScroll' >
                    <div className='Home_IntroduceContent'>
                        <div className='Home_JoinUs'>
                            <div className='Home_IntroduceContentLeft'>

                                <div className='Home_JoinUs_Title'>
                                    <div className='Home_JoinUs_TitleLeft'>
                                        <img className='Home_JoinUs_TitleIcon' src='images/ThreeUs/JoinUs/01.png'/>
                                        <div className='Home_JoinUs_TitleText'>{"联系我们>>加入我们"}</div>
                                    </div>
                                </div>
                                <div className='Home_JoinUs_JobList'>
                                    {JobList.map((job) => {
                                        return <JobCard data={job} />
                                    })}
                                </div>
                                <div className='Home_JoinUs_Bottom'>
                                    <div className='JoinUsCard_Name'>
                                        <img className='JoinUsCard_NameIcon' src='images/ThreeUs/JoinUs/03.png'/>
                                        <div className='JoinUsCard_NameText'>联系方式</div>
                                    </div>
                                    <div className='JoinUsCard_Content'>
                                        <div className='JoinUsCard_ResponsibilityList'>
                                            <div className='JoinUsCard_Responsibility'>简历及作品请发送至邮箱：nsicat_master@aircas.ac.cn</div>
                                        </div>
                                        <div className='JoinUsCard_RequirementList'>
                                            <div className='JoinUsCard_Requirement'>邮件标题注明：“姓名+应聘职位+手机号码” · 为了更加全面的了解您，建议您在您的附件中加入个人作品（如有）</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <MainBottom data={unitsList} />
                </div>
            </div>
        </div>
    )
}

const JobCard = (props) => {
    const { data } = props;
    return (
        <div className='JoinUsCard'>
            <div className='JoinUsCard_Name'>
                <img className='JoinUsCard_NameIcon' src='images/ThreeUs/JoinUs/02.png'/>
                <div className='JoinUsCard_NameText'>{data.JobName}</div>
            </div>
            <div className='JoinUsCard_Content'>
                <div className='JoinUsCard_ResponsibilityList'>
                    <div className='JoinUsCard_ResponsibilityTitle'>岗位职责：</div>
                    {data.responsibility.map((res) => {
                        return <div className='JoinUsCard_Responsibility'>{res}</div>
                    })}
                </div>
                <div className='JoinUsCard_RequirementList'>
                    <div className='JoinUsCard_RequirementTitle'>任职要求：</div>
                    {data.requirement.map((req) => {
                        return <div className='JoinUsCard_Requirement'>{req}</div>
                    })}
                </div>
            </div>
        </div>
    )
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch) => ({
})
export default connect(mapState, mapDispatch)(JoinUs);